<div class="policy-shell container">
	<article class="entry">
		<header class="policy-header">
			<nav class="policy-nav">
				<a class="textlink" [href]="'/'" role="menuitem">
					portfolio
				</a>
				<a class="textlink" [href]="'/blog'" role="menuitem" >
					blog
				</a>
				<div class="nav-right">
					<app-logo-context-menu></app-logo-context-menu>
				</div>
			</nav>
			<h1>Cookie Policy</h1>
			<p class="last-updated">Last Updated: July 13, 2026</p>
		</header>
		<div class="policy-content entry-content">
			<section>
				<h2>1. What Are Cookies?</h2>
				<p>
					Cookies are small text files that are stored on your device (computer, tablet, or mobile phone) when you
					visit a website. Cookies help websites recognize your device and store information about your preferences
					and browsing behavior. Cookies can be either "persistent" (stored until deleted or they expire) or "session"
					(deleted when you close your browser).
				</p>
			</section>
			<section>
				<h2>2. Why We Use Cookies</h2>
				<p>
					We use cookies and similar tracking technologies on our website and mobile applications for the following purposes:
				</p>

				<h3>2.1 Essential Cookies</h3>
				<p>
					These cookies are necessary for the website to function properly and cannot be disabled in our systems. They
					are used to:
				</p>
				<ul>
					<li>Enable basic website functionality and navigation</li>
					<li>Authenticate your login and maintain your session</li>
					<li>Implement security measures and detect fraudulent activity</li>
					<li>Comply with legal obligations</li>
				</ul>

				<h3>2.2 Performance and Analytics Cookies</h3>
				<p>
					These cookies help us understand how visitors use our website and services. They collect anonymous information
					such as:
				</p>
				<ul>
					<li>Pages visited and time spent on each page</li>
					<li>Referring website or search terms used</li>
					<li>Browser type and device information</li>
					<li>Geographic location (based on IP address)</li>
				</ul>
				<p>
					This information allows us to improve the user experience, fix technical issues, and optimize website
					performance. We use analytics tools such as Google Analytics for this purpose.
				</p>

				<h3>2.3 Preference Cookies</h3>
				<p>
					These cookies remember your choices and preferences to provide a customized experience. They store:
				</p>
				<ul>
					<li>Language and regional preferences</li>
					<li>Display settings and themes</li>
					<li>Accessibility preferences</li>
					<li>Previously viewed content</li>
				</ul>

				<h3>2.4 Marketing and Advertising Cookies</h3>
				<p>
					These cookies are used to deliver targeted advertising and marketing campaigns based on your interests and
					browsing behavior. They allow us to:
				</p>
				<ul>
					<li>Track your interactions across multiple websites</li>
					<li>Deliver personalized ads and promotional content</li>
					<li>Measure the effectiveness of advertising campaigns</li>
					<li>Build audience profiles for retargeting</li>
				</ul>
				<p>
					Marketing cookies are typically set by third-party advertising networks and require your consent.
				</p>

				<h3>2.5 Social Media Cookies</h3>
				<p>
					If you link your social media account to our Services or use social sharing features, cookies may be placed
					by social media platforms to track your interactions and enable social functionality.
				</p>
			</section>

			<section>
				<h2>3. Types of Tracking Technologies</h2>
				<p>
					In addition to cookies, we use other tracking technologies:
				</p>
				<ul>
					<li><strong>Web Beacons:</strong> Small graphics embedded in content used to track page visits and user engagement</li>
					<li><strong>Pixels:</strong> Small code snippets that track user actions and interactions</li>
					<li><strong>Local Storage:</strong> Browser storage mechanism similar to cookies that persists data on your device</li>
					<li><strong>Mobile Tracking:</strong> Unique device identifiers and mobile analytics tools for app users</li>
				</ul>
			</section>

			<section>
				<h2>4. Third-Party Cookies</h2>
				<p>
					Some cookies are set by third-party service providers, including:
				</p>
				<ul>
					<li><strong>Google Analytics:</strong> For website traffic analysis and user behavior tracking</li>
					<li><strong>Advertising Networks:</strong> For targeted advertising and campaign measurement</li>
					<li><strong>Social Media Platforms:</strong> Such as Facebook, Twitter, LinkedIn, and Instagram</li>
					<li><strong>Content Delivery Networks:</strong> For optimizing website performance</li>
					<li><strong>Customer Service Tools:</strong> For chat support and customer feedback</li>
				</ul>
				<p>
					These third parties have their own privacy policies and cookie practices, and we encourage you to review them.
				</p>
			</section>

			<section>
				<h2>5. Consent Management</h2>
				<h3>5.1 Cookie Consent Banner</h3>
				<p>
					When you first visit our website, you will see a cookie consent banner. This banner allows you to:
				</p>
				<ul>
					<li>Accept all cookies</li>
					<li>Reject all non-essential cookies</li>
					<!--li>Customize your cookie preferences</li-->
					<li>View this Cookie Policy for more information</li>
				</ul>

				<h3>5.2 Changing Your Cookie Preferences</h3>
				<p>
					You can change your cookie preferences at any time by:
				</p>
				<ul>
					<li>Clicking the cookie consent banner (if available) on our website</li>
					<li>Adjusting browser settings to reject or delete cookies</li>
					<li>Using browser extensions that block cookies</li>
				</ul>
				<p>
					Please note that disabling certain cookies may affect the functionality and performance of our website.
				</p>
			</section>

			<section>
				<h2>6. How to Control Cookies</h2>
				<h3>6.1 Browser Settings</h3>
				<p>
					Most browsers allow you to control cookies through their settings. You can typically:
				</p>
				<ul>
					<li>View cookies stored on your device</li>
					<li>Delete cookies automatically or manually</li>
					<li>Block all cookies or specific types of cookies</li>
					<li>Block pop-ups and other tracking technologies</li>
				</ul>
				<p>
					For information on how to manage cookies in your specific browser, visit:
				</p>
				<ul>
					<li><strong>Chrome:</strong>&nbsp;<a href="https://support.google.com/chrome/answer/95647" target="_blank">support.google.com/chrome</a></li>
					<li><strong>Firefox:</strong>&nbsp;<a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank">support.mozilla.org</a></li>
					<li><strong>Safari:</strong>&nbsp;<a href="https://support.apple.com/en-us/HT201265" target="_blank">support.apple.com</a></li>
					<li><strong>Microsoft Edge:</strong>&nbsp;<a href="https://support.microsoft.com/en-US/edge/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use" target="_blank">support.microsoft.com</a></li>
				</ul>

				<h3>6.2 Opt-Out Tools</h3>
				<p>
					To opt out of cookies set by advertising networks and other third parties, you can use:
				</p>
				<ul>
					<li><strong>Digital Advertising Alliance (DAA):</strong>&nbsp;<a href="https://optout.aboutads.info/" target="_blank">optout.aboutads.info</a></li>
					<li><strong>Network Advertising Initiative (NAI):</strong>&nbsp;<a href="https://optout.networkadvertising.org/" target="_blank">optout.networkadvertising.org</a></li>
					<li><strong>European Interactive Digital Advertising Alliance (EDAA):</strong>&nbsp;<a href="https://www.youronlinechoices.eu/" target="_blank">youronlinechoices.eu</a></li>
				</ul>

				<h3>6.3 Do Not Track (DNT)</h3>
				<p>
					Many browsers include a "Do Not Track" (DNT) feature. However, DNT signals are not uniformly recognized or
					honored by websites. We currently do not respond to DNT signals, but you can still control cookies through
					your browser settings.
				</p>
			</section>

			<section>
				<h2>7. Data Security</h2>
				<p>
					We implement appropriate security measures to protect cookies and data collected through tracking technologies.
					However, no method of transmission over the Internet is 100% secure. We encourage you to use strong passwords
					and keep your browser and devices up to date with security patches.
				</p>
			</section>

			<section>
				<h2>8. Compliance with Regulations</h2>
				<p>
					Our cookie practices comply with applicable privacy laws, including:
				</p>
				<ul>
					<li><strong>GDPR (General Data Protection Regulation):</strong> For users in the European Union and EEA</li>
					<li><strong>CCPA (California Consumer Privacy Act):</strong> For California residents</li>
					<li><strong>PIPEDA (Personal Information Protection and Electronic Documents Act):</strong> For Canadian users</li>
					<li><strong>Other applicable privacy laws</strong></li>
				</ul>
				<p>
					We obtain your consent before placing non-essential cookies on your device, and we provide clear information
					about how we use cookies.
				</p>
			</section>

			<section>
				<h2>9. Changes to This Cookie Policy</h2>
				<p>
					We may update this Cookie Policy from time to time. We will notify you of any material changes by posting the
					updated Cookie Policy on our website and updating the "Last Updated" date. Your continued use of our Services
					after such notification constitutes your acceptance of the updated Cookie Policy.
				</p>
			</section>

			<section>
				<h2>10. Contact Us</h2>
				<p>
					If you have questions about this Cookie Policy or our use of cookies, please contact us at:
				</p>
				<div class="contact-info">
					<p>Email: create&commat;nhdsgn.com</p>
				</div>
			</section>
		</div>
	</article>
</div>
<nh-footer></nh-footer>